import React, { useState, useEffect, useRef } from "react";
import ActionBar from "../../common/ActionBar";
import { Formik } from "formik";
import {
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  makeStyles,
  AppBar,
  Tabs,
  Tab,
} from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import NoticeAudit from "./component/NoticeAudit";
import UploadAudit from "./component/UploadAudit";
import labels from "../../../helpers/labels.json";
import PropTypes from "prop-types";
import _ from "lodash";
import { navigate } from "@reach/router";
import { fadeIn } from "../../Mis/styles";
import useUser from "../../../hooks/useUser";
import queryString from "query-string";
import CaseService from "../../../services/CaseService";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  overflow: auto;
`;

const radio_inputs = [
  {
    label: "Maker",
    name: "maker",
    value: "maker",
  },
  {
    label: "Checker",
    name: "checker",
    value: "checker",
  },
];

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },
}));

export default function FinalApprover() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { userObject } = useUser();
  const MTRef = useRef();
  const [menuItems, setMenuItems] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    async function getParties() {
      try {
        setLoader({ state: true });
        let params = {
          page: 1,
          perPage: 1000,
          role: "caseManager",
        };
        let stringParams = "";
        if (!_.isEmpty(params)) {
          stringParams = `?${queryString.stringify(params)}`;
        }
        const response_cmlist = await CaseService.getCMlist(stringParams);
        if (response_cmlist?.data?.length) {
          setMenuItems(
            response_cmlist?.data.map(({ name, email, id }) => ({
              value: id,
              name,
              email,
            })),
          );
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    getParties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "dashboard":
        navigate("/dashboard/case-manager");
        break;
      default:
        break;
    }
  };

  return (
    <div className="paymentHistory">
      <ActionBar
        breadcrumbs={["Dashboard", "Final Approver"]}
        {...{ onBreadcrumbClick }}
      />

      <Formik
        initialValues={{
          auditor: "maker",
        }}
        enableReinitialize
        validateOnBlur
        validateOnChange
        onSubmit={"onFormSubmit"}
      >
        {({
          values,
          handleChange,
          errors,
          handleSubmit,
          touched,
          setFieldValue,
          setFieldError,
          handleBlur,
          isValid,
        }) => (
          <form>
            <Grid
              className={classes.radioRoot}
              item
              xs={12}
              spacing={2}
              style={{ marginTop: "5px", padding: 16 }}
            >
              <RadioGroup
                style={{
                  flexDirection: "row",
                  marginLeft: "10px",
                }}
                name={"auditor"}
                value={values.auditor}
                onChange={(e) => {
                  setFieldValue("auditor", e.target.value);
                  MTRef.current.onQueryChange(MTRef?.current?.state?.query);
                }}
              >
                {radio_inputs.map((radio, key) => (
                  <FormControlLabel
                    {...{ key }}
                    classes={{ label: classes.formLabel }}
                    value={radio.value}
                    control={
                      <Radio size="medium" style={{ color: "#00838c" }} />
                    }
                    label={radio.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <div className={classes.root}>
              <AppBar className={classes.appBar} position="static">
                <Tabs
                  value={value}
                  indicatorColor="primary"
                  onChange={(_, newValue) => setValue(newValue)}
                  aria-label="pending-action-tab"
                >
                  <StyledTab
                    label={
                      <div className={classes.label}>
                        {labels.notice_generation}
                      </div>
                    }
                    {...a11yProps(0)}
                  />
                  <StyledTab
                    label={
                      <div className={classes.label}>
                        {labels.document_upload}
                      </div>
                    }
                    {...a11yProps(1)}
                  />
                </Tabs>
              </AppBar>

              <TabPanel value={value} index={0}>
                {userObject?.id && (
                  <NoticeAudit
                    auditor={values.auditor}
                    id={userObject?.id}
                    {...{ MTRef, menuItems }}
                  />
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                <UploadAudit
                  auditor={values.auditor}
                  id={userObject?.id}
                  {...{ MTRef, menuItems }}
                />
              </TabPanel>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export const TableWrapper = styled.div`
  animation: ${fadeIn} 0.8s ease-in-out;
`;

const StyledTab = styled(Tab)`
  min-width: auto !important;
  padding: 8px 12px !important;
  text-transform: none !important;
  font-family: "openSans-Bold", sans-serif !important;
  font-size: 12px !important;
  color: #6b7280 !important;
  transition: all 0.3s ease !important;
  border-radius: 8px 8px 0 0;

  @media (min-width: 640px) {
    padding: 12px 24px !important;
    font-size: 16px !important;
  }

  &.Mui-selected {
    color: #00838c !important;
    background: rgba(0, 131, 140, 0.05);
  }

  .MuiTab-wrapper {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    @media (max-width: 639px) {
      flex-direction: column;
      gap: 4px;
    }
  }
`;
